import { render, staticRenderFns } from "./enrollSetting.vue?vue&type=template&id=2351f86c&scoped=true"
import script from "./enrollSetting.vue?vue&type=script&lang=ts"
export * from "./enrollSetting.vue?vue&type=script&lang=ts"
import style0 from "./enrollSetting.vue?vue&type=style&index=0&id=2351f86c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351f86c",
  null
  
)

export default component.exports